import { render, staticRenderFns } from "./PaymentMicroDepositsDialog.vue?vue&type=template&id=54175114&scoped=true"
import script from "./PaymentMicroDepositsDialog.vue?vue&type=script&lang=js"
export * from "./PaymentMicroDepositsDialog.vue?vue&type=script&lang=js"
import style0 from "./PaymentMicroDepositsDialog.vue?vue&type=style&index=0&id=54175114&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54175114",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54175114')) {
      api.createRecord('54175114', component.options)
    } else {
      api.reload('54175114', component.options)
    }
    module.hot.accept("./PaymentMicroDepositsDialog.vue?vue&type=template&id=54175114&scoped=true", function () {
      api.rerender('54175114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/payment/PaymentMicroDepositsDialog.vue"
export default component.exports